import { Box, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { ReactNode } from "react";

export type AlarmDashboardChartContainerProps = {
    children?: ReactNode;
    sx?: SxProps<Theme>
};

export default function AlarmDashboardChartContainer({
    children,
    sx
}: AlarmDashboardChartContainerProps) {

   return (
       <Box
           sx={{
               display: 'flex',

               flexBasis: {
                   xs: 'auto', 
                   sm: '33%'
               },

               minHeight: 500,
               ...sx
           }}>
           {children}
       </Box>
   );
}
